import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import dateUtil from '../utils/date.util'
import itemApi, { ItemData } from '../apis/item.api'
import customerApi, { CustomerData } from '../apis/customer.api'
import itemService from '../services/item.service'
import SearchPicker, { SearchPickerOption } from '../components/SearchPicker'
import Card from '../components/Card'
import Row from '../components/Row/Row'
import CustomDatePicker from '../components/CustomDatePicker'
import PageHeading from '../components/PageHeading'
import ReportButtons from './ReportButtons'
import customerService from '../services/customer.service'
import InputText from '../components/InputText'

interface Props {
  onSearchClick: (data: ShippingReportFormData) => void
  onExportClick: (data: ShippingReportFormData) => void
}

interface State {
  fromDate: string
  toDate: string
  item: string
  itemId: number | null
  customer: string
  customerId: number | null
  lpn: string
  items: ItemData[]
  customers: CustomerData[]
}

export interface ShippingReportFormData {
  fromDate: string
  toDate: string
  itemId: number | null
  customerId: number | null
  lpn: string
}

export default class ShippingReportForm
  extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      fromDate: dateUtil.now(),
      toDate: dateUtil.now(),
      item: '',
      itemId: null,
      customer: '',
      customerId: null,
      lpn: '',
      items: [],
      customers: []
    }
    this.handleDateChange = this.handleDateChange.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleSearch = this.handleSearch.bind(this)
    this.handleSearchSelect = this.handleSearchSelect.bind(this)
    this.handleSearchClick = this.handleSearchClick.bind(this)
    this.handleExportClick = this.handleExportClick.bind(this)
    this.handleSearchPickerBlur = this.handleSearchPickerBlur.bind(this)
  }

  get itemSearchOptions () {
    return itemService.searchOptions(this.state.items)
  }

  get customerSearchOptions () {
    return customerService.searchOptions(this.state.customers)
  }

  searchItems (term: string) {
    itemApi.search(term, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  searchCustomers (term: string) {
    customerApi.search(term, customers => {
      if (!customers) return
      this.setState({ customers })
    })
  }

  get formData (): ShippingReportFormData {
    const { fromDate, toDate, itemId, customerId, lpn } = this.state
    return { fromDate, toDate, itemId, customerId, lpn }
  }

  searchItem (term: string) {
    if (!term) {
      this.setState({ items: [] })
      return
    }
    itemApi.search(term, items => {
      if (!items) return
      this.setState({ items })
    })
  }

  handleDateChange (name: string, date: string) {
    if (name === 'from') this.setState({ fromDate: date })
    if (name === 'to') this.setState({ toDate: date })
  }

  handleInputChange (name: string, value: string) {
    if (name === 'item') {
      this.setState({ itemId: null, item: value })
    } else if (name === 'customer') {
      this.setState({ customerId: null, customer: value })
    } else if (name === 'lpn') this.setState({ lpn: value })
  }

  handleSearch (name: string, term: string) {
    if (name === 'item') this.searchItems(term)
    if (name === 'customer') this.searchCustomers(term)
  }

  handleSearchPickerBlur (name: string) {
    if (name === 'item') {
      this.setState({ items: [] })
    }
    if (name === 'customer') {
      this.setState({ customers: [] })
    }
  }

  handleSearchSelect (name: string, option: SearchPickerOption) {
    const id = option.id as number
    if (name === 'item') this.setState({ itemId: id, items: [] })
    if (name === 'customer') this.setState({ customerId: id, customers: [] })
  }

  handleSearchClick () {
    this.props.onSearchClick(this.formData)
  }

  handleExportClick () {
    this.props.onExportClick(this.formData)
  }

  render () {
    return (
      <Card>
        <PageHeading
          text={i18n("Shipping Report")}
          doc='reports-preview-and-export-shipping-report' />
        <Row column={2}>
          <CustomDatePicker
            from={this.state.fromDate}
            to={this.state.toDate}
            time={true}
            onChange={this.handleDateChange} />
          <Row column={2}>
            <SearchPicker
              name="item"
              value={this.state.item}
              options={this.itemSearchOptions}
              label={i18n("Item")}
              onSearch={this.handleSearch}
              onSelect={this.handleSearchSelect}
              onChange={this.handleInputChange}
              onBlur={this.handleSearchPickerBlur} />
            <SearchPicker
              name="customer"
              value={this.state.customer}
              options={this.customerSearchOptions}
              label={i18n("Customer")}
              onSearch={this.handleSearch}
              onSelect={this.handleSearchSelect}
              onChange={this.handleInputChange}
              onBlur={this.handleSearchPickerBlur} />
            <InputText
              name="lpn"
              value={this.state.lpn}
              label={i18n("LPN")}
              onChange={this.handleInputChange} />
          </Row>
        </Row>
        <ReportButtons
          onSearch={this.handleSearchClick}
          onExport={this.handleExportClick} />
      </Card>
    )
  }
}
